 <template>
  <v-menu v-bind="attrs.componentAttrs">
    <slot name="default">
      <v-list class="rounded-lg py-0" :data-locator="attrs.dataLocator" elevation="2" v-if="menu.length !== 0">
        <template v-for="(item, index) in menu" :key="`item${index}`">
            <v-divider v-if="item.title === 'separator'"/>
            <v-list-item v-else
              :key="`item${index}`"
              :class="item.style"
              :data-locator=item.locatorValue
              :disabled="item.loading || item.disabled"
              @click="doItemAction(item)"
            >
            <v-progress-circular v-if="item.loading"
                                 indeterminate
                                 color="primary"
                                 size="24"
                                 class="mr-2"
            />
            <v-list-item-title class="d-flex align-center column-gap-2">
              <span class="d-flex align-center justify-center icon-wrapper">
                <template v-if="!iconAfter && item.icon">
                  <app-icon-ds :icon="item.icon" size="xs" color="inherit" />
                </template>
                <template v-if="item.iconComponent">
                  <component :is="item.iconComponent" />
                </template>
              </span>
              <span v-html="item.title"></span>
              <template v-if="iconAfter && item.icon">
                <app-icon-ds :icon="item.icon" size="xs" color="inherit" />
              </template>
              <AppFeatureTag v-if="item.featureTag" size="sm" :tag="item.featureTag" class="ml-2" />
            </v-list-item-title>
          </v-list-item>
        </template>
      <slot name="append"></slot>
      </v-list>
    </slot>
    <template v-slot:activator="attrs">
      <slot name="activator" v-bind="attrs"></slot>
    </template>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import AppFeatureTag from '@/common/AppFeatureTag.vue'
import { useDataLocator } from '@/common/utils/useDataLocator'
import type { MenuItemType } from '@/types/menu.d.ts'

export default defineComponent({
  name: 'AppMenu',
  inheritAttrs: false,
  setup() {
    const { attrs } = useDataLocator()
    return { attrs }
  },
  components: { AppFeatureTag },
  props: {
    menu: {
      type: Array as PropType<MenuItemType[]>,
      default: () => [],
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    doItemAction(item: MenuItemType): void {
      item.action(item)
    },
  },
})
</script>

<style scoped lang="scss">
.icon-wrapper {
  height: 20px;
  width: 20px;
}
</style>
